<template>
    <div v-if="screenWidth <= 800 ? false : true">
        <el-table :data="fileList" stripe :height="innerHeight <= 400 ? 400 : innerHeight- 150" size="small"
            @row-click="tabClick" v-loading="loading" :summary-method="getSummaries" show-summary
            :row-class-name="tableRowClassName" @sort-change='sort' row-key="id">
            <el-table-column v-for="(item, index) in tableHeads" :key="index" :label="item.label" :fixed="item.fixed"
                :prop="item.property" show-overflow-tooltip :sortable="item.sort">
                <template #header>
                    {{item.label}}
                    <el-tooltip effect="light" v-if="item.tooltip" :content="item.tooltip">
                        <el-icon style="font-size: 12px; color: bottom: ;">
                            <InfoFilled />
                        </el-icon>
                    </el-tooltip>
                </template>
                <template #default="scope">
                    <template v-if="item.type == 'picture' && scope.row[item.property].length">
                        <el-image v-for="(ist, i) in scope.row[item.property]" :key="i"
                            style="width: 50px; height: 50px" :src="ist" fit="contain" />
                    </template>
                    <template v-else-if="item.type == 'multipleSelect' && scope.row[item.property].length">
                        <el-tag v-for="(ist, i) in scope.row[item.property]" :key="i">{{ist}}</el-tag>
                    </template>
                    <template v-else-if="item.type == 'rate-over'">
                        <span :class="{ 'cell-green': overHundred(scope.row[item.property]) }">{{ scope.row[item.property] }}</span>
                    </template>
                    <template v-else-if="item.type == 'diff'">
                        <span :class="diffClass(scope.row[item.property])">{{ scope.row[item.property] }}</span>
                    </template>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="br_con" v-loading="loading" v-else>
        <el-space wrap size="default" alignment="flex-start" :fill="screenWidth <= 800 ? true : false">
            <el-card style="width: 300px" v-for="(item, index) in fileList" :key="index">
                <el-descriptions direction="vertical" :column="2" size="small" border>
                    <el-descriptions-item v-for="(v, i) in tableHeads" :key="i" :label="v.label">
                        {{item[v.property]}}
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
            <el-card style="width: 300px;">
                <el-empty description="没有数据" />
            </el-card>
        </el-space>
    </div>
    <div style="height: 25px;padding: 0;margin: 0;">
        <el-footer height='25'>
            <el-pagination :current-page="lookup.currentPage" background :page-size="lookup.pageSize"
                hide-on-single-page layout="prev, pager, next, jumper " :total="lookup.total"
                @size-change="handleCurrentChange" @current-change="handleCurrentChange" size="small" />
        </el-footer>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import {
        h
    } from 'vue'
    export default {
        name: "CatTable",
        props: {
            fileList: Array,
            tableHead: Array,
            lookup: Object,
            tabname: String,
            loading: Boolean
        },
        computed: {
            // Vue计算属性
            ...mapState(['innerHeight', 'screenWidth']),
            tableHeads: function() {
                // 只保留后端标记 hide 为真值的列；字段名与语义相反属历史遗留，
                // 当前线上行为依赖此约定，切勿按注释字面意思取反
                return this.tableHead.filter((item) => item.hide)
            }
        },
        emits: ['tabname', 'currentPage', 'rowvl', 'update:fileList'],
        methods: {
            sort(column) {
                // 排序（复制后排序，避免直接修改 prop，再回写父组件）
                let cmp
                if (column.order == 'descending') {
                    cmp = (a, b, v = column.prop) => parseFloat(a[v]) - parseFloat(b[v]) - 0
                } else if (column.order == 'ascending') {
                    cmp = (a, b, v = column.prop) => parseFloat(b[v]) - parseFloat(a[v]) - 0
                } else {
                    cmp = (a, b, v = 'index') => parseFloat(b[v]) - parseFloat(a[v]) - 0
                }
                this.$emit('update:fileList', [...this.fileList].sort(cmp))
            },
            handleCurrentChange(v) {
                this.$emit('currentPage', v)
            },
            tabClick(row) {
                //将数据传递给父组件
                this.$emit('rowvl', row)
            },
            overHundred(value) {
                return Number(value) > 100;
            },
            diffClass(value) {
                const n = Number(value);
                if (n > 0) return 'cell-green';
                if (n < 0) return 'cell-red';
                return '';
            },
            tableRowClassName({ // 把每一行的索引放进row 删除引用
                row,
                rowIndex
            }) {
                row.index = rowIndex
            },
            getSummaries(param) {
                const {
                    columns,
                    data
                } = param;
                const sums = [];

                columns.forEach((column, index) => {
                    // 第一列固定文案
                    if (index === 0) {
                        sums[index] = h('div', {}, '汇总');
                        return;
                    }

                    // 取出该列所有值，统一转成字符串
                    const values = data.map(item => String(item[column.property] ?? ''));

                    // 判定是否满足求和条件：全部为数字且长度 ≤ 9 避免手机号和纯数字单号求和
                    const allValid = values.every(v => {
                        const num = Number(v);
                        return !Number.isNaN(num) && v.length <= 9;
                    });

                    if (allValid) {
                        const total = values.reduce((sum, v) => sum + Number(v), 0);
                        sums[index] = `${total.toFixed(0)}`;
                    } else {
                        sums[index] = '-'; // 也可换成 'N/A'
                    }
                });

                return sums;
            }
        },
    }
</script>

<style scoped>
    .card-header {
        padding-left: 16px;
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .el-footer {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .cell-green {
        display: inline-block;
        color: #15803d;
        background-color: #dcfce7;
        padding: 2px 6px;
        border-radius: 3px;
    }

    .cell-red {
        display: inline-block;
        color: #b91c1c;
        background-color: #ffe4e6;
        padding: 2px 6px;
        border-radius: 3px;
    }
</style>